export default {"src":"/_next/static/media/0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487.fdde6fae.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};